export const ITALIC_BUTTON_DATA_HOOK = 'textInlineStyleButton_Italic';
